// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__CbaSc","checkboxCol":"Table_checkboxCol__3FSWa","emailCol":"Table_emailCol__348q2","actionCol":"Table_actionCol__1XD6G"};